import React, { useState } from 'react';
import Foto1 from '../../../../assets/images/QoS.png';
import Foto2 from '../../../../assets/images/QoS-2.png';
import Card from 'react-bootstrap/Card';

import 'bootstrap/dist/css/bootstrap.min.css';

function QoS() {
  return (
    <>
      <div className='container-fluid'>
        <div className='row'>
          <div className='col-sm-12 col-md-6'>
            <h1>Tecnologias - QoS</h1>
            <img src={Foto2} alt='problema' className='mb-0' />
            <Card className="text-center">
              <Card.Header><div className="opcoes">Tecnologias disponíveis</div></Card.Header>
              <Card.Body>
                {/* <Card.Title>Coleta de Informações e Análise do Ambiente</Card.Title> */}
                <Card.Text>
                  <div className='opcoes'>
                    <div>
                      <strong>1. Garantia de largura de banda: </strong>
                      A QoS assegura que aplicações críticas, como videoconferências 
                      e streaming, recebam a largura de banda necessária.
                    </div>
                    <br />
                    <div>
                      <strong>2. Prioritização de tráfego: </strong>
                      Diferentes tipos de tráfego são priorizados para otimizar o desempenho da rede.
                    </div>

                  </div>
                </Card.Text>
                {/* <Button variant="primary">Go somewhere</Button> */}
              </Card.Body>
              <Card.Footer className="text-muted">

              </Card.Footer>
            </Card>

          </div>
          <div className='col-sm-12 col-md-6'>
            <div className='imagem'>
              <img className="d-block w-100" src={Foto1} alt="Current slide" />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default QoS;
